import {DEFAULT_EVENT_CONTENT_COLORS} from '@Components/event-wizard/event-wizard.types';
import type {EventStyles} from '@Components/event-wizard/event-style/event-style.types';
import {onEventWizardStyleUpdate} from '@Components/event-wizard/event-wizard-slice';
import {applyEventWizardColorLegibility} from '@Components/event-wizard/event-wizard.helper';
import {getEventWizardColorLegibilityState} from '@Components/event-wizard/event-wizard.hooks';
import {applyContentSelection} from '@Libraries/event-colors.library';
import {PMW_COLORS_PRIMARY} from '@Utils/color.util';

/**
 * A new event that no preset colours carries over the user's latest event style when the user chose that colour, and
 * otherwise starts from a random default colour rather than PosterMyWall's own blue.
 */
export const applyNewEventDefaultStyle = (latestEventStyle: EventStyles | null): void => {
  if (latestEventStyle !== null && !isEventColorUnchosen(latestEventStyle)) {
    window.PMW.redux.store.dispatch(onEventWizardStyleUpdate(latestEventStyle));
    return;
  }

  applyRandomDefaultContentColor();
};

/**
 * PosterMyWall's blue was the default before these colours, so an event still on it did not choose it either.
 */
const isEventColorUnchosen = (style: EventStyles): boolean => {
  const primaryColor = style.colors.primary.toUpperCase();

  return primaryColor === PMW_COLORS_PRIMARY.PRIMARY_100 || DEFAULT_EVENT_CONTENT_COLORS.some((defaultColor: string): boolean => defaultColor === primaryColor);
};

/**
 * Applied exactly as a colour picked in the styles panel is.
 */
const applyRandomDefaultContentColor = (): void => {
  const currentLegibilityState = getEventWizardColorLegibilityState(window.PMW.redux.store.getState());

  applyEventWizardColorLegibility(applyContentSelection(currentLegibilityState, getRandomDefaultContentColor()));
};

const getRandomDefaultContentColor = (): string => {
  return DEFAULT_EVENT_CONTENT_COLORS[Math.floor(Math.random() * DEFAULT_EVENT_CONTENT_COLORS.length)];
};
